import moment from 'moment'

import {
  validate,
  isRequired,
  isFilesLessThan,
  isFilesValidExtension,
  isIndividualInn,
  isInn,
  isOgrn,
  isDate,
  isFullAge,
  isCyrillicFio,
  isPassportNumber,
  isPassportSeries,
  isPostalCode,
  isIssuingDate,
  isMinDate,
  isRequiredObject,
  isDriverLicense,
  isVehicleLicensePlate,
  isVehicleRegistrationCertificate,
  isVin,
  isPhone,
  isDateWithoutDay
} from '../../../services/validator'

const maxFileSize = 7
const extensions = ['jpg', 'jpeg', 'png', 'pdf', 'tiff', 'tif']

const fileRules = [
  files => isFilesValidExtension(files, extensions),
  files => isFilesLessThan(files, maxFileSize)
]

const allRules = {
  // персональные данные
  firstName: [isCyrillicFio],
  lastName: [isCyrillicFio],
  middleName: [isCyrillicFio],
  dateBirth: [isDate, isFullAge],
  placeBirth: [isCyrillicFio],
  position: [],
  // данные ип
  ipInn: [isIndividualInn],
  // данные компании
  orgName: [],
  orgInn: [isInn],
  orgOgrn: [isOgrn],
  okato: [],
  innOrOgrn: [val => (val.length > 10 ? isOgrn(val) : isInn(val))],
  // паспортные данные
  documentNumber: [isPassportNumber],
  documentSeries: [isPassportSeries],
  issuingAuthority: [],
  authorityCode: [],
  issuingDate: [isDate, isIssuingDate],
  // адрес прописки совпадает с фактическим
  income: [],
  // Транспорт
  driverLicense: [isDriverLicense],
  driverLicenseIssued: [isDate, isIssuingDate],
  vehicleLicensePlate: [isVehicleLicensePlate],
  vehicleRegistrationCertificate: [
    
    isVehicleRegistrationCertificate
  ],
  vin: [isVin],
  // адрес прописки
  propIndex: [isPostalCode],
  propCity: [],
  propRegion: [
    val => isRequired(val, 'Выберите регион'),
    val => isRequiredObject(val, 'Выберите регион')
  ],
  propStreet: [],
  propHouse: [],
  propAppartment: [],
  propCorp: [],
  // фактический адрес
  factIndex: [isPostalCode],
  factCity: [],
  factRegion: [],
  factStreet: [],
  factHouse: [],
  factAppartment: [],
  factCorp: [],
  phone: [val => isRequired(val, 'Введите телефон'), isPhone],
  // загружаемые файлы
  contractScan: fileRules,
  passportScan: fileRules,
  ogrnScan: fileRules,
  attorneyScan: fileRules,
  regions: [],
  agreementReceived: [],
  monitoringEndDate: [isDateWithoutDay],
}

function filterRules (fields) {
  return fields.reduce((rules, field) => {
    if (allRules.hasOwnProperty(field.name)) {
      let commonRules = [].concat(allRules[field.name]);
      if (field.required && !field.name.includes('Scan')) {
        commonRules.push(isRequired);
      }
      rules[field.name] = commonRules;
    }
    return rules
  }, {})
}

export function validateDefault (values, fields, isAgreementReceiptionRequired) {
  const rules = filterRules(fields);

  const dateBirthField = fields.find(x => {
    return x.name === 'dateBirth';
  });

  const issuingDateField = fields.find(x => {
    return x.name === 'issuingDate';
  });

  if (isAgreementReceiptionRequired) {
    rules.agreementReceived = [
      (val) => isRequired(val, 'Подтердите получение согласия субъекта на обработку его перс. данных'),
    ]
  }

  if (dateBirthField && issuingDateField) {
    rules.issuingDate.push(val => {
      const minDate =
        values.dateBirth &&
        moment(values.dateBirth.trim(), 'DD/MM/YYYY')
          .add(14, 'years')
          .format('DD/MM/YYYY')

      return isMinDate(val, minDate)
    })
  }

  if (values.sameAddress && values.sameAddress.length) {[
      'factIndex',
      'factCity',
      'factRegion',
      'factStreet',
      'factHouse',
      'factAppartment',
      'factCorp'
    ].map(field => {
      if (rules.hasOwnProperty(field)) {
        delete rules[field]
      }
    })
  }

  return validate(values, rules)
}



// WEBPACK FOOTER //
// ./src/modules/home/requestProfile/validate.js